
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-office-london-old-street",
      function () {
        return require("private-next-pages/virtual-office-london-old-street.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual-office-london-old-street"])
      });
    }
  